import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  width: 100%;
  min-width: 1200px;
  margin: auto;
  /* min-height: 100vh; */
  display: flex;
  /* & > div:first-child {
    margin-right: 70px;
  } */
  .component_page_wrapper {
    background-color: ${color.grey3};
    padding-top: 24px;
    padding-bottom: 36px;
    width: 100%;
    min-height: 100vh;
  }
`;

export default Wrapper;
